import Button               from "@mui/material/Button";
import Dialog               from "@mui/material/Dialog";
import DialogTitle          from "@mui/material/DialogTitle";
import DialogContent        from "@mui/material/DialogContent";
import DialogContentText    from "@mui/material/DialogContentText";
import DialogActions        from "@mui/material/DialogActions";
import { UseMutationResult } from "react-query";
import {
    DIALOG_DELETE_TITLE,
    DIALOG_DELETE_CONFIRM,
    DIALOG_DELETE_DISCARD,
    DIALOG_DELETE_CONTENT_1,
    DIALOG_DELETE_CONTENT_2,
    DIALOG_DELETE_CONTENT_3
}                           from "config/config";

interface DeleteStudentDialogProps {
    dialogOpen: boolean,
    idToDelete: string,
    getStudentName: (id: string)=>string,
    setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setIdToDelete: React.Dispatch<React.SetStateAction<string>>,
    studentDelete: UseMutationResult<void, unknown, string, unknown>
};

export default function DeleteStudentDialog(props: DeleteStudentDialogProps){
    return(
        <Dialog
            open={props.dialogOpen}
            onClose={()=>props.setDialogOpen(false)}
        >
            <DialogTitle>{DIALOG_DELETE_TITLE}</DialogTitle>
            <DialogContent sx={{pl: 3}}>
                <DialogContentText>  
                    {DIALOG_DELETE_CONTENT_1} <b>{props.getStudentName(props.idToDelete)}</b> {DIALOG_DELETE_CONTENT_2}
                    {" "}{DIALOG_DELETE_CONTENT_3}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{pr: 3}}>
                <Button autoFocus
                    color='secondary'
                    sx={{mr: 1}}
                    onClick={()=>{
                        props.setDialogOpen(false);
                        props.setIdToDelete('');
                    }
                }>
                    {DIALOG_DELETE_DISCARD}
                </Button>
                <Button
                    onClick={()=>{
                        props.studentDelete.mutate(props.idToDelete);
                        props.setDialogOpen(false);
                        props.setIdToDelete('');
                    }}
                >
                    {DIALOG_DELETE_CONFIRM}
                </Button>
            </DialogActions>
        </Dialog>
    )
};